import React from 'react'
import { Layers } from 'lucide-react'
import { PlaceholderPage } from '@/components/PlaceholderPage'

export const UsageAggregatedPage: React.FC = () => (
  <PlaceholderPage
    icon={Layers}
    titleKey="business.usageAggregatedTitle"
    descriptionKey="business.usageAggregatedDescription"
  />
)
